"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printStrategy = exports.default = exports.DEFAULT_FALLBACK_PRINT_TIMEOUT_INTERVAL = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const toolTypes = Object.freeze({
  TOOLS_BOARD: "toolsBoard",
  QUICK_TOOLS: "quickTools",
  RHP: "rhp",
  CONTEXT_MENU: "contextMenu",
  NAVIGATION_BAR: "navigationBar"
});
const printStrategy = exports.printStrategy = Object.freeze({
  BROWSER_PRINT: "useBrowserOnly",
  BROWSER_OR_HTML_PRINT: "preferBrowserOverHTMLPrint",
  HTML_PRINT_ONLY: "useHTMLPrintOnly",
  INTEGRATION_PRINT: "useIntegrationPrint"
});
const DEFAULT_FALLBACK_PRINT_TIMEOUT_INTERVAL = exports.DEFAULT_FALLBACK_PRINT_TIMEOUT_INTERVAL = 5000;
var _default = exports.default = toolTypes;